<template>
  <div class="iframePulldownDataConfiger">
    <!-- 仅当开关开启时显示弹框入口 -->
    <div>
      <div class="is-show-bottom">
        <el-button type="primary" @click="showDialog = true">添加监控数据</el-button>
      </div>
    </div>
    <div class="custom-dialog-mask" v-show="showDialog" @click="handleMaskClick">
      <div class="custom-dialog-content">
        <!-- 弹框标题 -->
        <div class="dialog-header">
          <h3>监控选择数据</h3>
          <i class="el-icon-close" @click="showDialog = false"></i>
        </div>

        <!-- 表格内容 -->
        <div class="dialog-body">
          <table class="dark-table">
            <thead>
              <tr>
                <th></th>
                <th>名称</th>
                <th>编码</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in value.selectorData" :key="index">
                <td>
                  <i
                    class="el-icon-delete"
                    @click="value.selectorData.length > 1 ? deleteRow(index) : null"
                    :class="{ 'is-disabled': value.selectorData.length === 1 }"
                    :style="{
                      color: value.selectorData.length === 1 ? '#666' : '#ff4d4f',
                      cursor: value.selectorData.length === 1 ? 'not-allowed' : 'pointer',
                    }"
                  ></i>
                </td>
                <td><input type="text" v-model="item.name" class="table-input" /></td>
                <td><input type="text" v-model="item.code" class="table-input" /></td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 添加行按钮 -->
        <div class="add-row-btn">
          <el-button icon="el-icon-plus" type="text" @click="addRow" style="color: #409eff">
            添加行
          </el-button>
        </div>

        <!-- 操作按钮 -->
        <div class="dialog-footer">
          <el-button @click="showDialog = false">取消</el-button>
          <el-button type="primary" @click="handleApply">应用</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'iframePulldownDataConfiger',
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      showDialog: false, // 控制弹框显示的核心变量
      value: {},
    };
  },
  mounted() {
    this.value = this.propertyData.iframeConfiger.value;
  },
  methods: {
    // 开关状态变化时更新数据
    changeSetting() {
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: this.value,
      });
    },
    // 添加行
    addRow() {
      this.value.selectorData.push({ name: '', code: '' });
    },
    // 删除行（保留至少1行）
    deleteRow(index) {
      if (index > 0) {
        // 保留至少1行
        this.value.selectorData.splice(index, 1);
      }
    },
    // 应用修改
    handleApply() {
      this.changeSetting();
      this.showDialog = false;
    },
    // 点击遮罩关闭弹框（避免点击内容区域时关闭）
    handleMaskClick(e) {
      if (e.target === e.currentTarget) {
        this.showDialog = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* 开关区域样式 */
.is-show-right {
  padding: 0 15px;
  height: 43px;
  color: #a0a1b4;
  font-size: 14px;
  line-height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.is-show-bottom {
  padding: 0 15px;
}
:deep().el-button {
  font-size: 12px;
  width: 100%;
  min-height: 36px;
  padding: 10px 16px;
}
:deep().el-button--primary {
  background: linear-gradient(143deg, #335ae9, #6f6ff5);
  color: white;
}
/* 弹框遮罩层 */
.custom-dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 弹框内容区域 */
.custom-dialog-content {
  overflow: hidden;
  overflow-y: auto;
  width: 600px;
  background-color: #20212b;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  padding: 20px;
  height: 560px;
}

/* 弹框标题 */
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #2c3e50;
}

.dialog-header h3 {
  font-size: 18px;
  font-weight: normal;
}

.dialog-header .el-icon-close {
  cursor: pointer;
  font-size: 20px;
  color: #a0a1b4;
}

/* 表格样式 */
.dark-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 15px;
}

.dark-table th,
.dark-table td {
  padding: 8px 6px;
  text-align: left;
  color: #fff;
  border-bottom: 1px solid #2c2e3f;
}

.dark-table th {
  background-color: #2c2e3f;
  font-weight: normal;
}

/* 表格输入框 */
.table-input {
  width: 100%;
  padding: 8px 10px;
  background-color: #2c2e3f;
  border: 1px solid #2c2e3f;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
  box-sizing: border-box;
}

.table-input:focus {
  outline: none;
  border-color: #409eff;
}

/* 添加行按钮 */
.add-row-btn {
  margin: 10px 0;
  text-align: left;
}

/* 弹框底部按钮 */
.dialog-footer {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #2c3e50;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* Element UI按钮样式调整（保持与主题一致） */
:deep().el-button {
  font-size: 12px;
  min-height: 36px;
  padding: 10px 16px;
  background-color: #2c2e3f;
  border-color: #2c2e3f;
  color: #fff;
}

:deep().el-button--primary {
  background: linear-gradient(143deg, #335ae9, #6f6ff5);
  border: none;
}

:deep().el-button:hover {
  background-color: #1f2d3d;
}
</style>
